import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { PresenterResourcesService } from './presenter-resources.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-presenter-resources-dashboard',
  templateUrl: './presenter-resources-dashboard.component.html',
  styleUrls: ['./presenter-resources-dashboard.component.scss']
})
export class PresenterResourcesDashboardComponent implements OnInit, OnDestroy {
  obj_container: any = [];
  env: any;
  
  private destroy$ = new Subject<void>();

  constructor(
    public router: Router,
    public store: Store<any>,
    private presenterResourcesService: PresenterResourcesService
  ) {}

  ngOnInit() {
    console.log('🚀 PresenterResourcesDashboardComponent initialized');
    this.env = environment;
    
    // Load learner maps from Redux store
    this.presenterResourcesService.getFormattedLearnerMaps()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        formattedMaps => {
          console.log('✅ Component received formatted maps:', formattedMaps);
          this.obj_container = formattedMaps;
          console.log('📊 obj_container updated with', this.obj_container.length, 'items');
        },
        error => {
          console.error('❌ Error loading learner maps:', error);
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
